import React from 'react'
import Spinner from 'react-bootstrap/Spinner';
function ButtonLoader() {
    return (
        <div><Spinner animation="border" variant="light" /></div>
    )
}

export default ButtonLoader